import { __assign } from "tslib";
// DS: I122
import React from 'react';
import IconWrap from '../../IconWrap';
var Subfolders = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
        React.createElement("path", { fillRule: "evenodd", d: "M18 11a1 1 0 011 1v8a1 1 0 01-1 1H6a1 1 0 01-1-1v-8a1 1 0 011-1h12zm-1 2H7v4h10v-4zm-1-6a1 1 0 010 2H8a1 1 0 110-2h8zm-2-4.002a1 1 0 01.993.883L15 4a1 1 0 01-1 1h-4a1 1 0 01-.993-.883L9 3.998a1 1 0 011-1h4z" })))); };
Subfolders.displayName = 'Subfolders';
export default Subfolders;
//# sourceMappingURL=Subfolders.js.map